import React, { Component } from 'react'
import classNames from 'class-names'
import without from 'lodash.without'
import union from 'lodash.union'
import Toast from '../../components/Toast'
import SchoolDetail from '../School/Detail/index'
import iconAdd from '../../assets/icon-select.svg'
import iconAdded from '../../assets/icon-selected.svg'
import './SchoolDetail.less'
import backIcon from "../../assets/ic_fanhui.png";
import Popup from "../../components/Popup";

class Detail extends Component {

  state = {
    showToast: false,
    toastIcon: 'deleted',
    toastText1: '',
    toastText2: '',
  }
  handleAdd(data, selected,e) {
      const { selectedSchoolIds,selectedSchoolList } = this.props;
      const modify = data.id;
      if(selected){
          const newIds = without(selectedSchoolIds, modify);
          const newList=selectedSchoolList.filter(i=>i.id!=modify);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'deleted' ,
                  toastText1:  '已删除' ,
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }else {
          if(selectedSchoolList.length>=20){
              this.setState({
                  showMaxTips:true
              })
          }else {
              const newIds = union(selectedSchoolIds, [modify]);
              const newList= union(selectedSchoolList,[data]);
              this.setState(() => {
                  return {
                      showToast: true,
                      toastIcon:  'success',
                      toastText1: '已添加',
                      toastText2: data.name,
                  }
              });
              this.props.onSelectChange(newIds,newList)
              e.stopPropagation()
          }
      }
  }

  handleBackToWish() {
    const { history } = this.props
    history.push(`/schoolwishlist`)
  }
  handleBackToChoose(){
      const { history } = this.props
      history.push(`/schoolwishlist/choose`)
  }
  renderBtn(school) {
    const { selectedSchoolIds } = this.props
    const added = selectedSchoolIds.includes(school.id)
    const cls1 = classNames({
      'btn-operation': true,
      'added': added,
    });
    return <div className='btn-operation-outer'>
        <div className={cls1} onClick={this.handleAdd.bind(this, school, added)}>
            <img className="icon-add" src={added ? iconAdded : iconAdd} alt="icon" />
            <span>{added ? '已选' : '选择'}</span>
        </div>
    </div>
  }

  render() {
    const {
      showToast,
      toastIcon,
      toastText1,
      toastText2,
    } = this.state
    return (
      <div className="xkcoach-school-detail">
          <header>
              <div className = "home-container">
                  <div className="back" onClick={()=>{window.history.back()}}>
                      <img src={backIcon} alt=""/>
                      返回
                  </div>
              </div>
          </header>
          <SchoolDetail
          renderOperationBtn={this.renderBtn.bind(this)}
          onBack={this.handleBackToChoose.bind(this)}
          hideBottomBtn={true}
          {...this.props}
        />
        {/*<div className="bottom-btn">*/}
        {/*  <button className="primary full" onClick={this.handleBackToWish.bind(this)}>返回意向学校清单</button>*/}
        {/*</div>*/}
        <Toast show={showToast} icon={toastIcon} onHide={() => this.setState({ showToast: false })}>
          <i>{toastText1}</i>
          <p>{toastText2}</p>
        </Toast>
          <Popup confirmText="我知道了" show={this.state.showMaxTips} onConfirm={() => this.setState({ showMaxTips: false })}>
              <div>
                  <div className="max-tips">
                      <h3>提示</h3>
                      <p>当前你已选择20所学校，已达到可选学校数量上限。</p>
                  </div>
              </div>
          </Popup>
      </div>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/SchoolWishListNew/SchoolDetail.js